import { render, staticRenderFns } from "./orderMixed.vue?vue&type=template&id=2ce1462d&scoped=true"
import script from "./orderMixed.vue?vue&type=script&lang=js"
export * from "./orderMixed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce1462d",
  null
  
)

export default component.exports